var scope_0 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1bcba0c820d75859ae5b5726653916ce.js').default;

var scope_1 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/220d16e1b8a18850644da10f8c9be980.js').default;

var scope_2 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/29d47eb847a7de364f92ce6270870058.js').default;

var scope_3 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/32e6baf8b384c549a22273fbc1e0826c.js').default;

var scope_4 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4914a09c83b34d30cc4b2ba209bc4c5b.js').default;

var scope_5 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6453b841674fa7d3689f1f24ee4d9c67.js').default;

var scope_6 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6c642ee665b544ae65bdc79f988923b4.js').default;

var scope_7 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/718cba4259c0b5cd405d73eb82e62ca6.js').default;

var scope_8 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7a3a9b4b6be0d2c9281a45993ef3880a.js').default;

var scope_9 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7baecc6795b889910ce7b12f23fa7e2d.js').default;

var scope_10 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7e91684265058794513eaf0a9d1e4fd7.js').default;

var scope_11 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/822160193f87ade70f5a17cbd229abdb.js').default;

var scope_12 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/83fd73aa4060b9ba624b9d00f8e19041.js').default;

var scope_13 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8dd2dde7483a315279a8fe6b9634f6b2.js').default;

var scope_14 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/be95da1f2b26f2b4cebcbb2f2b16a77e.js').default;

var scope_15 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c6f4362651f1c1946f76f6213b8033e9.js').default;

var scope_16 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d22df44eba1a8880b4f3e2caba1381ba.js').default;

var scope_17 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ddbc4d17b95e650983fbc9a0d0bb713d.js').default;

var scope_18 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var scope_19 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f2c915c3596cc2cafe420a6ba0b98883.js').default;

var scope_20 = require('/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f530b6dd43146c16a34a4be51c080f3d.js').default;

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14, scope_15, scope_16, scope_17, scope_18, scope_19, scope_20);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}